export default "__VITE_ASSET__CCFAPlB0__"